import React, {useState, useRef, useMemo} from 'react';
import TextBox from "devextreme-react/text-box";
import {formatMessage} from "devextreme/localization";
import Validator, {RequiredRule, EmailRule} from "devextreme-react/validator";
import {formatMessageExt} from "../../utils/helpers";
import ValidationGroup from "devextreme-react/validation-group";
import {useFormData} from "../../utils/form-data";
import {SingleCard} from "../../layouts";
import {Alert, DogrulamaYontemi, GoogleRecaptcha, PasswordText} from "../../components";
import Button from "devextreme-react/button";
import {useAppState} from "../../contexts/app-state";
import notify from "devextreme/ui/notify";

const errorsInit = () => { return  { message : false, email : false, validate : false, captcha: false } };
const createFormData = () => {
    // adnroid WebView da localStorage kapalı gelebiliyor.
    // bu kısım sadece cep telefonunda google hesabı eklede hatırlamasına gerek yok
    // localStorage.getItem() değer yoksa null döndürür
    // let storedLoginName =  window.localStorage ? localStorage.getItem('loginName') : '';

    return {
      //  email : storedLoginName ? storedLoginName : '',
        // hatırlamasın
        email : '',
        parola : '',
        yontem : '',
        dogrulama : '',
        captchaResponse: false,
    };
}

export default function ({ dogrulandi }) {
    const { state } = useAppState();
    const [isBusy, setIsBusy] = useState(false);
    const [showCaptcha, setShowCaptcha] = useState(false);
    const [error, setError] = useState(()=> errorsInit());
    const { formData, setInputValue, setInputValues, inputChangeHandler } = useFormData(createFormData());
    const refScrollView = useRef(null);
    const refValidationGroup = useRef(null);
    const refEmail = useRef(null);
    const refRecaptcha = useRef(null);
    const sayfaAyar = useMemo(()=> state.pages.find(e => e.component === 'SifreDegistirSayfa'), [state.pages]);

    const displayCaptcha = () => (sayfaAyar && sayfaAyar.showCaptcha) || showCaptcha;
    const sifreDegistir = (e) => {
        if (!refValidationGroup.current.instance.validate().isValid) {
            return;
        }

        if (displayCaptcha() && !formData.captchaResponse) {
            setError({...error, captcha: formatMessage('validation.robot') });
            return;
        }

        setError(errorsInit());
        setIsBusy(true);

        const { email, parola, captchaResponse, yontem, dogrulama } = formData;
        const data = displayCaptcha()
            ? { email, parola, yontem, dogrulama, captchaResponse}
            : { email, parola, yontem, dogrulama };

        fetch("/ui/sifre-degistir",
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify( data)
            })
            .then((response) => response.json())
            .then((res) => {
                if (res.success) {
                    dogrulandi(res);
                } else {
                    setInputValue('captchaResponse', false);
                    setError(res.error);
                    setShowCaptcha(res.showCaptcha);
                    setIsBusy(false);
                    if (refScrollView.current) {
                        refScrollView.current.instance
                            .scrollToElement(document.querySelector('#kq-header'));
                    }
                    if(refRecaptcha.current) {
                        refRecaptcha.current.reset();
                    }
                }
            })
            .catch((error) => {
                notify(formatMessage('oops'), "error", 2000);
                if (state.debug) {
                    console.error(error);
                }
                setIsBusy(false);
            });
    }

   // console.log(displayCaptcha())

    return <SingleCard disabled={isBusy}
                       ref={refScrollView}
                       title={formatMessage('sifreDegistir.baslik')}
                       page="SifreDegistirSayfa">
        {error.message && <Alert type="error"
                                 iconClass="fa fa-2x fa-exclamation-circle"
                                 message={error.message} />}
        <div className={isBusy ? 'kq-progress-line' : 'kq-line'}/>
        <ValidationGroup ref={refValidationGroup}>
            <div className="kq-form">
                <TextBox placeholder={formatMessage('sifreDegistir.email')}
                         readOnly={isBusy}
                         ref={refEmail}
                         defaultValue={formData.email}
                         autoComplete="off"
                         onValueChanged={inputChangeHandler('email')}
                         stylingMode={'filled'}>
                    <Validator>
                        <RequiredRule message={formatMessageExt('validation.isRequired', ['email'])} />
                        <EmailRule message={formatMessageExt('validation.notValid', ['email'])} />
                    </Validator>
                </TextBox>

                <br />
                <PasswordText placeholder={formatMessage('sifreDegistir.sifre')}
                              readOnly={isBusy}
                              defaultValue={formData.parola}
                              displayButton={true}
                              onValueChanged={inputChangeHandler('parola')}>
                    <Validator>
                        <RequiredRule message={formatMessageExt('validation.isRequired', ['sifre'])} />
                    </Validator>
                </PasswordText>

                <br/>
                <DogrulamaYontemi defaultValue={formData.dogrulama}
                                  setInputValues={setInputValues}
                                  disabled={isBusy} />

                {displayCaptcha() && <br/>}
                {displayCaptcha() &&
                    <GoogleRecaptcha ref={refRecaptcha}
                                     verifyCallback={(captchaResponse)=>{
                                         setInputValue('captchaResponse', captchaResponse)
                                     }}
                                     error={error.captcha}/>}

                <br/>
                <Button width="100%" type="default" disabled={isBusy} onClick={sifreDegistir}>
                <span className="dx-button-text">
                    { formatMessage('gonder') }
                </span>
                </Button>

            </div>
        </ValidationGroup>
    </SingleCard>
}